<template id="Duplicata">
<Modele id="Duplicata_permis"></Modele>
</template>

<script>
import Modele from '../Modele.vue'
export default {
	components:{Modele},
	name: 'Duplicata',
	data () {
		return {}
	}
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Conduite/Duplicata_permis.vue